import React from 'react';
import { connect } from 'react-redux';

import { withFormik, Field } from 'formik';
import * as yup from 'yup';

import ButtonCustom from 'components/ButtonCustom';

import FieldInputComponent from 'components/FieldInputComponent';
import FieldCheckboxComponent from 'components/FieldCheckboxComponent';
import { toggleTermsOfServicesModal } from 'store/modules/modals';
import { toggleTermsOfServices } from 'store/modules/profileDetails/actions';

import { MIN_PASSWORD_LENGTH } from 'helpers/constants';

import { Form } from 'reactstrap';

const SignUpSchema = yup.object().shape({
  email: yup
    .string()
    .email('Invalid email address')
    .required("Email can't be empty"),
  password: yup
    .string()
    .min(
      MIN_PASSWORD_LENGTH,
      `Password has to be longer than ${MIN_PASSWORD_LENGTH} characters!`,
    )
    .required("Password can't be empty"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], "Passwords don't match")
    .required("Confirm Password can't be empty"),
  receiveEmail: yup.boolean(),
});

const EnhancedForm = ({
  isSubmitting,
  handleSubmit,
  isValid,
  touched,
  errors,
  toggleTermsOfServicesModal,
  toggleTermsOfServices,
  agreeToTerms,
  values,
  trialLinkDays,
}) => {
  // TODO: I think anywhere exist better solution :)
  values.agreeToTerms = agreeToTerms;

  return (
    <Form className="order-form">
      <div className="h2-title big center">Sign Up</div>
      {(trialLinkDays !== '' && trialLinkDays !== null) ?
        (<div className="text text-300 center">You will be register for {trialLinkDays} days trial access</div>) :
        <div className="text text-300 center">Enter your information below</div>}
      <div className="separator-line" />
      <Field
        name="full_name"
        component={FieldInputComponent}
        error={touched.full_name && errors.full_name}
        type="text"
        label="Full name"
        placeholder="What is your full name?"
        classInput="form-input input-border"
      />
      <Field
        name="email"
        component={FieldInputComponent}
        error={touched.email && errors.email}
        type="text"
        label="Email"
        placeholder="example@mail.com"
        classInput="form-input input-border"
      />
      <Field
        name="password"
        component={FieldInputComponent}
        error={touched.password && errors.password}
        type="password"
        label="Password"
        placeholder="Your passsword (8 chars or more)"
        classInput="form-input input-border"
      />
      <Field
        name="confirmPassword"
        component={FieldInputComponent}
        error={touched.confirmPassword && errors.confirmPassword}
        type="password"
        label="Confirm Password"
        placeholder="Confirm your passsword "
        classInput="form-input input-border"
      />
      <Field
        name="agreeToTerms"
        type="checkbox"
        component={FieldCheckboxComponent}
        labelText="Yes, I agree to the"
        labelLink="Terms of Service"
        labelLinkRoutes="#"
        labelLinkOnClick={toggleTermsOfServicesModal}
        onClickHandler={toggleTermsOfServices}
        checked={agreeToTerms}
      />
      <Field
        name="receiveEmail"
        component={FieldCheckboxComponent}
        labelText="Yes, I'd like to receive occasional email updates"
      />
      <div className="order-form__btn">
        <ButtonCustom
          className="btn btn-blue big"
          type="submit"
          onClick={handleSubmit}
          disabled={
            !isValid ||
            (isValid && isSubmitting) ||
            (isValid && !isSubmitting && !agreeToTerms)
          }>
          {isSubmitting ? 'Loading' : ' Sign up'}
        </ButtonCustom>
      </div>
    </Form>
  );
};

const mapStateToProps = state => ({
  agreeToTerms: state.details.user.agree_to_terms,
});

const mapDispatchToProps = {
  toggleTermsOfServicesModal,
  toggleTermsOfServices,
};

const UserFormSignUp = withFormik({
  mapPropsToValues: () => ({
    full_name: '',
    email: '',
    password: '',
    confirmPassword: '',
    agreeToTerms: false,
    receiveEmail: false,
    trialLinkDays: null,
  }),
  isInitialValid: false,
  validationSchema: SignUpSchema,
  validateOnChange: true,
  handleSubmit: async (values, { props, setSubmitting, setErrors }) => {
    await props.handleSubmit(values, setSubmitting, setErrors);
  },
})(EnhancedForm);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserFormSignUp);



// WEBPACK FOOTER //
// ./src/scenes/SignUp/UserFormSignUp.js